<template>
  <div
    v-if="assetTrayGrouping"
    class="asset-tray-activator"
    @click="toggleAssetTray"
  >
    <div class="circle">
      <icon
        name="file-folder"
      />
    </div>
    <span>{{ showAssetTray ? "Hide" : "View" }} Patient Files</span>
  </div>
</template>

<script>
import Icon from '@/components/singletons/icon';
import AssetTrayMixin from '@/mixins/asset-tray';

export default {
  components: {
    Icon,
  },
  mixins: [AssetTrayMixin],
  props: {
    flashcard: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.asset-tray-activator {
  align-items: center;
  background-color: #EFF4FF;
  border-radius: 0 0 rem-calc(12) rem-calc(12);
  border-top: 1px solid #8FADFF;
  color: #155EEF;
  display: flex;
  font-weight: 600;
  font-size: rem-calc(14);
  gap: rem-calc(12);
  justify-content: center;
  margin-left: -0.75rem;
  margin-right: -0.75rem;
  margin-bottom: -0.75rem;
  margin-top: rem-calc(24);
  padding: rem-calc(12);
}

.circle {
  background-color: #D1E0FF;
  border-radius: 50%;
  display: grid;
  height: rem-calc(28);
  place-items: center;
  width: rem-calc(28);
}
</style>
